import { render, staticRenderFns } from "./DetailedView.vue?vue&type=template&id=76d124f1&scoped=true&"
import script from "./DetailedView.vue?vue&type=script&lang=js&"
export * from "./DetailedView.vue?vue&type=script&lang=js&"
import style0 from "./DetailedView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailedView.vue?vue&type=style&index=1&id=76d124f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d124f1",
  null
  
)

export default component.exports